import Button from 'components/button';
import styles from './styles.module.scss';
import ClearInputButton from 'components/clear-input-button';
import BottomSheet from 'components/bottom-sheet';
import ChooseMapPolygon from './ChooseMapPolygon';
import { MarketTypes } from 'api/types';
import { useState } from 'react';
import { IPolygonItemRequest } from 'api/hooks/use-apartments-limits-secondary';

interface IPolygonFilterData {
  onClearPolygon: () => void;
  type: MarketTypes;
  selectedPolygonCount: number;
  polygons: IPolygonItemRequest[];
}

const PolygonFilterData = ({
  selectedPolygonCount,
  type,
  onClearPolygon,
  polygons,
}: IPolygonFilterData) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={styles.polygonFilterData__container}>
        <div style={{ width: 'max-content' }}>
          Выбранно областей: <span>{selectedPolygonCount}</span>
        </div>
        <div>
          <Button
            variant='secondary'
            variantHeight='less'
            label='Открыть карту'
            onClick={() => setIsOpen(true)}
          />
        </div>
      </div>
      <div className={styles.polygonFilterData__clearButton}>
        <ClearInputButton onClick={() => onClearPolygon()} />
      </div>

      <BottomSheet
        open={isOpen}
        onDismiss={() => setIsOpen(false)}
        snapPoints={({ minHeight, maxHeight }) => [maxHeight, maxHeight]}
      >
        <div className={styles.polygonFilterData__map}>
          <ChooseMapPolygon type={type} polygonItems={polygons} />
        </div>

        <div style={{ paddingTop: 12 }}>
          <Button
            onClick={() => setIsOpen(false)}
            variant='gray'
            variantHeight='less'
            label='Закрыть'
          />
        </div>
      </BottomSheet>
    </>
  );
};
export default PolygonFilterData;
